/*
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-06-27 10:11:00
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-07-15 09:53:50
 * @FilePath: \frontend\src\api\PublicParams\PublicParams.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;
if (base == undefined) {
    base = process.env.NODE_ENV == "production" ? window.apiAdress : 'http://localhost:9291';
}

//字典管理
export const GetPublicParamsLs = params => {
    return axios.get(`${base}/api/PublicParams/Get`, { params: params });
};
export const DeletePublicParamsByIds = params => {
    return axios.delete(`${base}/api/PublicParams/Delete`, { params: params });
};
export const AddPublicParams = params => {
    return axios.post(`${base}/api/PublicParams/Post`, params);
};
export const PutPublicParams = params => {
    return axios.put(`${base}/api/PublicParams/Put`, params);
};
//缓存字典
export const GetCachingPassParams = params => {
    return axios.get(`${base}/api/PublicParams/GetCachingParams`, { params: params });
};